import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { ServiceAvailabilityService } from '../service-availability.service';
import { SharedService } from '../../shared/shared.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { FirstLetterUpperCase } from '../../shared/pipe/firstletteruppercase.pipe';
import { LowerCasePipe } from '@angular/common';
import { FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { TDUModel } from '../../shared/models/shared-models';

declare var google; // global variable declare

@Component({
	selector: 'tdu-details',
	templateUrl: './tdu-details.component.html',
	providers: [LowerCasePipe]
})
export class TDUDetailsComponent implements OnInit {

	// validation field required
	serviceAddressFormControl = new FormControl('', [Validators.required]);
	apartmentFormControl = new FormControl('', [Validators.required]);

	// public variable define
	public tdus: TDUModel[] = [];
	public zipcode: string;
	public duns: string;
	public error_message: string;
	public apt_units: any = [];
	public apt_unit: string;
	public apartment_list: any = [];
	public apartment_obs: Observable<string[]>;
	public is_loader: boolean;
	public esiid: string;
	public old_key: number;
	public which_event: string;
	public places: any;
	public is_address_addlis: boolean;
	public search_val: any;

	// define constructor
	constructor(private activatedRoute: ActivatedRoute,
		private _serviceAvailability: ServiceAvailabilityService, private router: Router,
		private sharedService: SharedService, private localStorageService: LocalStorageService,
		private firstLetterPipe: FirstLetterUpperCase, private lowerCasePipe: LowerCasePipe) {

		if (this.localStorageService.get('token') != null) {
			this.sharedService.verifyToken({ 'token': this.localStorageService.get('token') })
				.then(res => {
					if (res.status === 'success' && res.isTerminated === false) {
						this.router.navigate(['./dashboard']);
					} else {
						this.localStorageService.remove('token');
						this.router.navigate(['./sign-in']);
					}
				});
		}
		else {
			this.zipcode = '';
			this.is_loader = true;
			this.apt_unit = '';
			this.esiid = '';
			this.which_event = '';
			this.is_address_addlis = false;
			this.sharedService.setHeaderTitle('tdu_detail_hide');
			this.sharedService.setLoader('tdu_detail', true);
			this.activatedRoute.params.subscribe((params: Params) => {

				if (params['zipcode']) {
					this.zipcode = params['zipcode'];
				}

				this.sharedService.getTDUsByZipCode(this.zipcode)
					.then(tdusByZipCode => {

						if (tdusByZipCode.status != 'success') {
							this.router.navigate(['./service-not-available']);
						}

						this.tdus = tdusByZipCode.tdus;
						this.sharedService.setHeaderTitle('tdu_detail');
						this.is_loader = false;
						this.sharedService.setLoader('tdu_detail', false);

						if (!tdusByZipCode.multipleRecord) {
							this.localStorageService.set('zipcode_for_enroll', this.zipcode);
							this.router.navigate(['./enroll/zipcode/' + this.zipcode + '/tdu/' + tdusByZipCode.tdus[0].name]);
						}

						const thisObj = this;
						setTimeout(function () {
							const address = 'Texas';
							const geocoder = new google.maps.Geocoder();
							geocoder.geocode({ 'address': address }, function (results, status) {
								if (status === google.maps.GeocoderStatus.OK) {
									const latitude = [results[0].geometry.viewport.getSouthWest().lat(),
									results[0].geometry.viewport.getSouthWest().lng()];
									const longitude = [results[0].geometry.viewport.getNorthEast().lat(),
									results[0].geometry.viewport.getNorthEast().lng()];
									const stateBound = new google.maps.LatLngBounds(
										new google.maps.LatLng(latitude[0], latitude[1]),
										new google.maps.LatLng(longitude[0], longitude[1])
									);
									const options = {
										bounds: stateBound,
										strictBounds: true,
										types: ['geocode']
									}
									thisObj.places = new google.maps.places.Autocomplete(document.getElementById('service_address_id'), options);
								}
							});
						}, 10);

						setTimeout(function () {
							google.maps.event.addListener(thisObj.places, 'place_changed', function () {
								if (thisObj.places !== undefined) {
									const place = thisObj.places.getPlace();
									thisObj.getPlaces(place, thisObj, thisObj.search_val, 'place');
								}
							});
							thisObj.is_address_addlis = true;
						}, 1000);
					});
			});
		}
	}

	// redirect to plan page
	redirectPlanDetail(tdu: string) {
		let makeUrl = './enroll';
		if (this.zipcode !== '') {
			makeUrl += '/zipcode/' + this.zipcode;
		}
		this.router.navigate([makeUrl + '/tdu/' + tdu]);
	}

	ngOnInit() {
		const len = document.getElementsByTagName('body')[0];
		len.classList.add('body_autocomplete');
	}

	addClass() {
		setTimeout(function () {
			// tslint:disable-next-line:max-line-length
			const setPos = <HTMLScriptElement>document.getElementsByClassName('cdk-overlay-pane')[document.getElementsByClassName('cdk-overlay-pane').length - 1];
			if (!setPos.classList.contains('tdu-apart-auto-cls')) {
				setPos.classList.add('tdu-apart-auto-cls');
			}
			setPos.parentElement.classList.add('cdk-overlay-container-static');
		}, 10);

		setTimeout(function () {
			const setcls = <HTMLScriptElement>document.getElementsByClassName('sidenav-container')[0];
			setcls.classList.add('nav-cls');
		}, 10);
	}

	removeClass() {
		const setcls = <HTMLScriptElement>document.getElementsByClassName('sidenav-container')[0];
		setcls.classList.remove('nav-cls');
		const removeCls = <HTMLScriptElement>document.getElementsByClassName('cdk-overlay-container')[0];
		if (removeCls.classList.contains('cdk-overlay-container-static')) {
			removeCls.classList.remove('cdk-overlay-container-static');
		}

	}

	findApartUnit(search_val: any) {
		const enter_key = search_val.keyCode || search_val.which;
		if (search_val.target.value === '' && document.getElementById('is_error_address') !== undefined) {
			document.getElementById('is_error_address').setAttribute('style', 'display:none');
		}
		if (search_val.target.value === '' && document.getElementById('is_error_address_yellow') !== undefined) {
			document.getElementById('is_error_address_yellow').setAttribute('style', 'display:none');
		}
		if (search_val.type === 'keyup' && (enter_key === 13) ||
			(this.old_key === 17 && enter_key === 86) || (this.old_key === 86 && enter_key === 17)) {
			document.getElementById('apartment').blur();
		}
		if (search_val.type === 'focusout') {
			if (search_val.target.value !== '') {
				this.chooseApartUnit(search_val.target.value, '');
			}
		}
		this.old_key = enter_key;
	}

	// getAddress method match address from ercot and validate it
	getAddress(search_val: any) {
		const enter_key = search_val.keyCode || search_val.which;
		const this_of_comp = this;
		this.which_event = '';
		this.search_val = search_val;
		if (!this.is_address_addlis) {
			google.maps.event.addListener(this_of_comp.places, 'place_changed', function () {
				if (this_of_comp.places !== undefined) {
					const place = this_of_comp.places.getPlace();
					this_of_comp.getPlaces(place, this_of_comp, this_of_comp.search_val, 'place');
				}
			});
			this.is_address_addlis = true;
		}
		if (search_val.target.value === '') {
			this.apt_unit = '';
			this.esiid = '';
			this.apartment_list = [];
			if (document.getElementById('is_error_address') !== undefined) {
				document.getElementById('is_error_address').setAttribute('style', 'display:none');
			}
			if (document.getElementById('is_error_address_yellow') !== undefined) {
				document.getElementById('is_error_address_yellow').setAttribute('style', 'display:none');
			}
			if (document.getElementById('is_apt_exist') !== undefined) {
				document.getElementById('is_apt_exist').setAttribute('style', 'display:none');
			}
			if (document.getElementById('home_next') !== undefined) {
				document.getElementById('home_next').setAttribute('disabled', '');
			}
		}
		if (search_val.type === 'keyup' && (enter_key === 13)) {
			document.getElementById('service_address_id').blur();
		}
		if (search_val.type === 'focusout') {
			this.apt_unit = '';
			this.apartment_list = [];
			document.getElementById('is_error_address').setAttribute('style', 'display:none');
			document.getElementById('is_error_address_yellow').setAttribute('style', 'display:none');
			document.getElementById('is_apt_exist').setAttribute('style', 'display:none');
			if (search_val.target.value !== '') {
				document.getElementById('is_loader').setAttribute('style', '');
				const geocoder = new google.maps.Geocoder();
				geocoder.geocode({ 'address': search_val.target.value }, function (results, status) {
					if (status === google.maps.GeocoderStatus.OK) {
						const place = results[0];
						this_of_comp.getPlaces(place, this_of_comp, search_val, 'geocode');
					} else {
						document.getElementById('is_error_address_yellow').removeAttribute('style');
						document.getElementById('is_error_address_yellow').innerHTML =
							'<p>' + this_of_comp.sharedService.getErrorMessage('address_not_found') + '</p>';
						document.getElementById('is_loader').setAttribute('style', 'display:none');
					}
				});
			}
		}
		this.old_key = enter_key;
	}

	getPlaces(place: any, this_of_comp: any, search_val: any, which_event: any) {
		if (which_event !== 'place' || (which_event === 'place' && this_of_comp.which_event === 'ex_case')) {
			this_of_comp.which_event = '';
			let apt = '';
			let street_number = '';
			let street_address = '';
			let zipcode = '';
			let city = '';
			if (place !== undefined) {
				if (place['address_components'] !== undefined) {
					for (let i = 0; i < place['address_components'].length; i++) {
						if (place['address_components'][i]['types'][0] === 'postal_code') {
							zipcode = place['address_components'][i]['short_name'];
						}
						if (place['address_components'][i]['types'][0] === 'street_number') {
							street_number = place['address_components'][i]['short_name'];
						}
						if (place['address_components'][i]['types'][0] === 'locality') {
							city = place['address_components'][i]['short_name'];
						}
						if (place['address_components'][i]['types'][0] === 'subpremise') {
							apt = place['address_components'][i]['short_name'];
						}
						if (place['address_components'][i]['types'][0] === 'route') {
							street_address = place['address_components'][i]['short_name'];
						}
					}

					if (street_address !== '' && zipcode !== '') {
						if (!(which_event === 'geocode' && street_number.indexOf('-') > -1)) {
							this_of_comp.addressMatch(apt, street_number, city, street_address, zipcode, search_val.target.value);
						} else {
							this_of_comp.which_event = 'ex_case';
							google.maps.event.trigger(this_of_comp.places, 'place_changed');
							return false;
						}
					} else if (zipcode !== '') {
						this_of_comp.zipcode = zipcode;
						this_of_comp.sharedService.getTDUs({ 'zipcode': zipcode })
							.then(res => {
								const loader = document.getElementById('is_loader');
								loader.setAttribute('style', 'display:none');
								if (res.status === 'success') {
									if (res.multiple) {
										this_of_comp.router.navigate(['./enroll/zipcode/' + this_of_comp.zipcode]);
									} else {
										this_of_comp.router.navigate(['./enroll/zipcode/' + this_of_comp.zipcode + '/tdu/' + res.tdu[0]]);
									}
									setTimeout(function () {
										const len = document.getElementsByTagName('body')[0];
										len.click();
									}, 100);
								} else {
									document.getElementById('is_error_address_yellow').removeAttribute('style');
									document.getElementById('is_error_address_yellow').innerHTML =
										'<p>' + this_of_comp.sharedService.getErrorMessage('address_not_found') + '</p>';
									document.getElementById('home_next').setAttribute('disabled', '');
								}
							});
					} else {
						document.getElementById('is_loader').setAttribute('style', 'display:none');
						document.getElementById('is_error_address_yellow').removeAttribute('style');
						document.getElementById('is_error_address_yellow').innerHTML =
							'<p>' + this_of_comp.sharedService.getErrorMessage('address_not_found') + '</p>';
						document.getElementById('home_next').setAttribute('disabled', '');
						document.getElementById('is_loader').setAttribute('style', 'display:none');
					}
				} else {
					document.getElementById('is_loader').setAttribute('style', 'display:none');
					document.getElementById('is_error_address_yellow').removeAttribute('style');
					document.getElementById('is_error_address_yellow').innerHTML =
						'<p>' + this_of_comp.sharedService.getErrorMessage('address_not_found') + '</p>';
					document.getElementById('home_next').setAttribute('disabled', '');
					document.getElementById('is_loader').setAttribute('style', 'display:none');
				}
			} else {
				document.getElementById('is_loader').setAttribute('style', 'display:none');
				document.getElementById('is_error_address_yellow').removeAttribute('style');
				document.getElementById('is_error_address_yellow').innerHTML =
					'<p>' + this_of_comp.sharedService.getErrorMessage('address_not_found') + '</p>';
				document.getElementById('home_next').setAttribute('disabled', '');
				document.getElementById('is_loader').setAttribute('style', 'display:none');
			}
		}
	}

	addressMatch(apt, street_number, city, street_address, zipcode, search_address) {
		if (zipcode !== '' && street_address !== '') {
			this.sharedService.getServiceAddressesByGoogle({
				'GoogleStreet_Number': street_number,
				'GoogleStreet': street_address, 'GooglePostal_Code': zipcode, 'GoogleCity': city
			})
				.then(res => {
					if (res.result.length > 0) {
						if (res.result.length === 1) {
							const address_obj = res.result[0];
							this.apt_units = res.result;
							for (let i = 0; i < this.apt_units.length; i++) {
								if (this.apt_units[i].apt_unit != null && this.apt_units[i].apt_unit !== '') {
									let apartment = this.apt_units[i].apt_unit;
									if (apartment.includes(' ')) {
										apartment = apartment.split(' ')[1];
									}
									this.apartment_list.push(apartment);
									this.apt_unit = apartment;
									const len = document.getElementsByTagName('body')[0];
									len.click();
								}
							}
							this.apartment_obs = this.apartmentFormControl.valueChanges.startWith(null)
								.map(val => val ? this.filter(val) : this.apartment_list.slice());
							this.chooseApartUnit('', address_obj);
						} else {
							document.getElementById('is_loader').setAttribute('style', 'display:none');
							this.apt_units = res.result;
							for (let i = 0; i < this.apt_units.length; i++) {
								if (this.apt_units[i].apt_unit != null && this.apt_units[i].apt_unit !== '') {
									let apartment = this.apt_units[i].apt_unit;
									if (apartment.includes(' ')) {
										apartment = apartment.split(' ')[1];
									}
									this.apartment_list.push(apartment);
									if (this.lowerCasePipe.transform(apt) === this.lowerCasePipe.transform(apartment)) {
										this.apt_unit = apartment;
										const len = document.getElementsByTagName('body')[0];
										len.click();
										this.chooseApartUnit(apartment, '');
									}
								}
							}
							if (this.apartment_list.length > 0) {
								this.apartment_obs = this.apartmentFormControl.valueChanges.startWith(null)
									.map(val => val ? this.filter(val) : this.apartment_list.slice());
								document.getElementById('is_apt_exist').removeAttribute('style');
								document.getElementById('is_error_address').setAttribute('style', 'display:none');
								document.getElementById('is_error_address_yellow').setAttribute('style', 'display:none');
								document.getElementById('apartment').focus();
							} else {
								for (let i = 0; i < this.apt_units.length; i++) {
									if (this.apt_units[i].street_number != null && this.apt_units[i].street_number !== '') {
										if (street_number !== '' &&
											this.lowerCasePipe.transform(street_number) === this.lowerCasePipe.transform(this.apt_units[i].street_number)) {
											this.chooseApartUnit('', this.apt_units[i]);
										}
										if (street_number === '' && search_address.includes(this.apt_units[i].street_number)) {
											this.chooseApartUnit('', this.apt_units[i]);
										}
									}
								}
							}
						}
					} else {
						document.getElementById('is_loader').setAttribute('style', 'display:none');
						document.getElementById('is_error_address_yellow').removeAttribute('style');
						document.getElementById('is_error_address_yellow').innerHTML =
							'<p>' + this.sharedService.getErrorMessage('address_not_found') + '</p>';
					}
				});
		} else {
			document.getElementById('is_error_address_yellow').removeAttribute('style');
			document.getElementById('is_error_address_yellow').innerHTML =
				'<p>' + this.sharedService.getErrorMessage('address_not_found') + '</p>';
			document.getElementById('is_loader').setAttribute('style', 'display:none');
		}
	}

	chooseApartUnit(apt_number: string, address_obj: any) {
		if (apt_number !== '') {
			for (let i = 0; i < this.apt_units.length; i++) {
				let apartment = this.apt_units[i].apt_unit;
				if (apartment != null) {
					if (apartment.includes(' ')) {
						apartment = apartment.split(' ')[1];
					}
				}
				if (apartment === apt_number) {
					address_obj = this.apt_units[i];
					this.apt_unit = apartment;
				}
			}
		}
		this.duns = address_obj.duns;
		this.esiid = address_obj.esi_id;
		this.localStorageService.set('address_for_billing', address_obj);
		this.sharedService.validateAddress({ 'ercotId': address_obj.id })
			.then(res => {
				if (document.getElementById('is_loader') !== undefined) {
					document.getElementById('is_loader').setAttribute('style', 'display:none');
				}
				if (res.status === 'success') {
					if (document.getElementById('is_error_address') !== undefined) {
						document.getElementById('is_error_address').setAttribute('style', 'display:none');
					}
					if (document.getElementById('is_error_address_yellow') !== undefined) {
						document.getElementById('is_error_address_yellow').setAttribute('style', 'display:none');
					}
					if (address_obj.apt_unit != null && address_obj.apt_unit !== '' && document.getElementById('is_apt_exist') !== undefined) {
						document.getElementById('is_apt_exist').removeAttribute('style');
					}

					this.sharedService.GetElectricUtilityProvider(this.duns).then(tdu => {
						if (tdu && tdu.tduCode) {
							this.router.navigate(['./enroll/esiid/' + this.esiid + '/tdu/' + tdu.tduCode]);
						}
					});

					setTimeout(function () {
						const len = document.getElementsByTagName('body')[0];
						len.click();
					}, 10);

				} else {
					if (res.color === 'yellow' && document.getElementById('is_error_address_yellow') !== undefined) {
						document.getElementById('is_error_address_yellow').removeAttribute('style');
						document.getElementById('is_error_address_yellow').innerHTML = '<p>' + res.message + '</p>';
					} else {
						if (document.getElementById('is_error_address') !== undefined) {
							document.getElementById('is_error_address').removeAttribute('style');
							document.getElementById('is_error_address').innerHTML = '<p>' + res.message + '</p>';
						}
					}
				}
			});
	}

	filter(val: string): string[] {
		return this.apartment_list.filter(option => option.toLowerCase().indexOf(val.toLowerCase()) === 0);
	}

}





// WEBPACK FOOTER //
// ./src/app/service-availability/tdu-details/tdu-details.component.ts